/** Billing currency — keep in sync with backend `APP_CURRENCY`. */
const raw = import.meta.env.VITE_APP_CURRENCY;
export const APP_CURRENCY = (
  typeof raw === 'string' && raw.trim() ? raw.trim() : 'AUD'
).toUpperCase();

export function formatMoney(
  amount: number,
  currency: string = APP_CURRENCY,
  opts: { fractionDigits?: number } = {}
): string {
  const digits = opts.fractionDigits ?? (Number.isInteger(amount) ? 0 : 2);
  return new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: currency.toUpperCase(),
    currencyDisplay: 'code',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(amount);
}
